import { render, staticRenderFns } from "./ExtendExpiration.vue?vue&type=template&id=1574b09c&scoped=true&"
import script from "./ExtendExpiration.vue?vue&type=script&lang=ts&"
export * from "./ExtendExpiration.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendExpiration.vue?vue&type=style&index=0&id=1574b09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1574b09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1574b09c')) {
      api.createRecord('1574b09c', component.options)
    } else {
      api.reload('1574b09c', component.options)
    }
    module.hot.accept("./ExtendExpiration.vue?vue&type=template&id=1574b09c&scoped=true&", function () {
      api.rerender('1574b09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/ExtendExpiration.vue"
export default component.exports